import React from 'react'
import heroImg from './image.png'
import logo from './logo.png'

export default function Hero(){
  return (
    <header className="relative">
      <div className="h-[66vh] md:h-[72vh] bg-center bg-cover" style={{backgroundImage: `url(${heroImg})`}}>
        <div className="absolute inset-0 bg-black/55"></div>
        <div className="relative z-10 max-w-6xl mx-auto px-6 py-20 text-center">
          <nav className="flex items-center justify-between text-white mb-12">
            <div className="flex items-center gap-3">
              <img src={logo} alt="VeliOğlu Logo" className="h-24 md:h-36 w-auto object-contain" />
            </div>
            <div className="hidden md:flex items-center gap-3">
              <a href="#hakkimizda" className="border border-white text-white px-4 py-2 text-sm rounded">Hakkımızda</a>
              <a href="#contact" className="border border-white text-white px-4 py-2 text-sm rounded">İletişim</a>
            </div>
          </nav>

          <h1 className="text-4xl md:text-6xl font-extrabold text-white uppercase drop-shadow-md">VeliOğlu Lojistik</h1>
          <p className="mt-4 text-sm md:text-base text-white/90 tracking-wider">Taşımacılık ve Lojistik Hizmetleri</p>

          <div className="mt-8">
            <button className="bg-[#7a1015] hover:bg-[#5e0b0f] text-white px-6 py-3 rounded uppercase font-semibold">Şirketimiz ve Hizmetlerimiz</button>
          </div>
        </div>
      </div>
    </header>
  )
}
